import { StyledMintArticle } from './MintArticle.styled';
import useIsMobile from '../../../hooks/useIsMobile';
import { IconButton } from '../..';
import { theme } from '../../../theme';

const ArticleImage = ({ imageUrl, imageAction }) => {
  return (
    <div className='article-image-container'>
      <img className='article-image' src={imageUrl} alt=""/>
      {imageAction &&
        <div className='article-image-action-hover'>
          <div className='article-image-action-button-holder'>
            <IconButton
              backgroundOverwrite={theme.background}
              borderOverwriteHover={theme.background}
              animated={true}
              onClick={imageAction}>
                <div className='article-image-action-button-content'>Click to Expand</div>
            </IconButton>
          </div>
        </div>
      }
      <div className='article-corner article-corner-tl'/>
      <div className='article-corner article-corner-tr'/>
      <div className='article-corner article-corner-bl'/>
      <div className='article-corner article-corner-br'/>
      <div className='article-image-decorator'/>
    </div>
  );
}

const MintArticle = ({ 
  logoBgColor='rgba(1, 194, 255, 1)', 
  imageAction = null, 
  logoUrl = '/assets/book.svg', 
  title = '', 
  imageUrl = '/assets/broadside_header_blue.png', 
  articleImageUrl='/assets/portrait.png', 
  headerLogoUrl = null, 
  noImage = false, 
  children,
  buttonsConfig = [
    {
      disabled: false,
      onClick: null
    },
    {
      disabled: true,
      onClick: null
    },
    {
      disabled: true,
      onClick: null
    }
  ]
}) => {
  const isMobile = useIsMobile();
  return (
    <StyledMintArticle>
      <div className='article-header' style={{ backgroundImage: `url(${imageUrl})`}}>
        {headerLogoUrl && <img className='article-header-logo' src={headerLogoUrl} alt="" />}
        {!isMobile && <div style={{ maxWidth: '70vw' }}>
          {title}
        </div>}
      </div>
      {noImage ? (
        <div className='article-container'>
          <div className='article-body-no-image'>
            {children}
          </div>
        </div>
        ) : !isMobile ? (
          <div className='article-container'>
            <div className='article-image-wrapper'>
              <ArticleImage imageUrl={articleImageUrl} imageAction={imageAction}/>
              {buttonsConfig.map((e, index) => (
                <IconButton
                  key={`article-button-${index}`}
                  rows={1.5}
                  disabled={e.disabled}
                  animated={true}
                  onClick={() => e.onClick ? e.onClick() : false}>
                  <div className='button-content'>
                    <img src='/assets/try_left.svg' alt=""/>
                    <div className='inner-content'>
                      <div>Level {index+1}</div>
                      <div className='state-indicator'>
                        {e.disabled ? "LOCKED" : "UNLOCKED"}
                      </div>                      
                    </div>
                    <img src='/assets/try_right.svg' alt=""/>
                  </div>
                </IconButton>  
              ))}
            </div>            
            <div className='article-separator' />
            <div className='article-body'>
              <div className='article-logo-container' style={{ background: logoBgColor }}>
                <img className='article-logo' src={logoUrl} alt=""/>
              </div>
              {children}
            </div>
          </div>
        ) : (
          <div className='article-container'>
            <div className='article-body-no-image'>
              <div style={{ maxWidth: '70vw' }}>
                {title}
              </div>
              <div className='article-logo-offset'>
                <div className='article-logo-container' style={{ background: logoBgColor }}>
                  <img className='article-logo' src={logoUrl} alt=""/>
                </div>
              </div>
              {children}
            </div>
          </div>
        )}
    </StyledMintArticle>
  );
};

export default MintArticle; 
